module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargadorDerecha-di-1c76c50d.png";